(function () {
  'use strict';

  function VigenciaVdrivers() {
    return {
      templateUrl: `configuracoes/vdrivers/subpaginas/vigencia/vigencia-vdrivers.tpl.html`,
      controller(ConfigVdriversService) {
        this.service = ConfigVdriversService;
      },
      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular
    .module('SubpaginasVdrivers')
    .directive('vigenciaVdrivers', VigenciaVdrivers);
}());
